export default "__VITE_ASSET__DYPMNaj1__"